import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import { UNIT_OF_MEASURE } from "../../state/product/Types"

class LabelUnitOfMeasure extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            measure: this.props.value || '',
            unit: this.props.unit || UNIT_OF_MEASURE.PIECE,
            format: this.props.format || 'short',
        }
        this.parseHoursMinutes = this.parseHoursMinutes.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            unit: nextProps.unit || UNIT_OF_MEASURE.PIECE,
            measure: nextProps.value || '',
            format: nextProps.format || 'short'
        })
    }

    parseHoursMinutes() {
        let hour = this.state.measure.split('.')[0] || '0'
        let minute = Math.trunc(parseFloat(this.state.measure) * 60 % 60).toString()
        return `${hour}:${minute}`
    }

    renderUnit() {
        switch (this.state.unit) {
            case UNIT_OF_MEASURE.PIECE:
                if (this.state.format === 'short') {
                    return this.state.measure
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.units_label_long"
                        defaultMessage="{measure} units"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.INCH:
                if (this.state.format === 'short') {
                    return `${this.state.measure} "`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.inches_label_long"
                        defaultMessage="{measure, plural, one {# inch} other {# inches}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.FOOT:
                if (this.state.format === 'short') {
                    return `${this.state.measure} '`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.foot_label_long"
                        defaultMessage="{measure, plural, one {# foot} other {# feet}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.YARD:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.yard_label_short"
                        defaultMessage="{measure} yd"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.yard_label_long"
                        defaultMessage="{measure, plural, one {# yard} other {# yards}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.MILE:
                if (this.state.format === 'short') {
                    return `${this.state.measure} mi`
                }
                    return <FormattedMessage
                        id="common.unit_of_measure.input.mile_label_long"
                        defaultMessage="{measure, plural, one {# mile} other {# miles}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.CENTIMETER:
                if (this.state.format === 'short') {
                    return `${this.state.measure} cm`
                }
                    return <FormattedMessage
                        id="common.unit_of_measure.input.centimeter_label_long"
                        defaultMessage="{measure, plural, one {# centimeter} other {# centimeters}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.METER:
                if (this.state.format === 'short') {
                    return `${this.state.measure} m`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.meters_label_long"
                        defaultMessage="{measure, plural, one {# meter} other {# meters}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.KILOMETER:
                if (this.state.format === 'short') {
                    return `${this.state.measure} km`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.kilometers_label_long"
                        defaultMessage="{measure, plural, one {# kilometer} other {# kilometers}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.SQUARE_METER:
                if (this.state.format === 'short') {
                    return `${this.state.measure} m²`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.square_meters_label_long"
                        defaultMessage="{measure, plural, one {# square meter} other {# square meters}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.CUBIC_METER:
                if (this.state.format === 'short') {
                    return `${this.state.measure} m3`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.cubic_meters_label_long"
                        defaultMessage="{measure, plural, one {# cubic meter} other {# cubic meters}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.LITER:
                if (this.state.format === 'short') {
                    return `${this.state.measure} l`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.liter_label_long"
                        defaultMessage="{measure, plural, one {# liter} other {# liters}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.MILLILITER:
                if (this.state.format === 'short') {
                    return `${this.state.measure} ml`
                }
                return <FormattedMessage
                            id="common.unit_of_measure.input.milliliter_label_long"
                            defaultMessage="{measure, plural, one {# milliliter} other {# milliliters}}"
                            values={{
                                measure: this.state.measure
                            }}
                        />
                
            case UNIT_OF_MEASURE.GRAM:
                if (this.state.format === 'short') {
                    return `${this.state.measure} g`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.gram_label_long"
                        defaultMessage="{measure, plural, one {# gram} other {# grams}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.KILOGRAM:
                if (this.state.format === 'short') {
                    return `${this.state.measure} kg`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.kilogram_label_long"
                        defaultMessage="{measure, plural, one {# kilogram} other {# kilograms}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.TON:
                if (this.state.format === 'short') {
                    return this.state.measure + " t"
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.ton_label_long"
                        defaultMessage="{measure, plural, one {# ton} other {# tons}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.OUNCE:
                if (this.state.format === 'short') {
                    return `${this.state.measure} oz`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.ounce_label_long"
                        defaultMessage="{measure, plural, one {# ounce} other {# ounces}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.GALLON:
                if (this.state.format === 'short') {
                    return `${this.state.measure} gal`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.gallon_label_long"
                        defaultMessage="{measure, plural, one {# gallon} other {# gallons}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.POUND:
                if (this.state.format === 'short') {
                    return `${this.state.measure} lb`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.pound_label_long"
                        defaultMessage="{measure, plural, one {# pound} other {# pounds}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.DAY:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.day_label_short"
                        defaultMessage="{measure, plural, one {# d} other {# d}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.day_label_long"
                        defaultMessage="{measure, plural, one {# day} other {# days}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.HOUR:
                if (this.state.format === 'short') {
                    return `${this.state.measure} h`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.hour_label_long"
                        defaultMessage="{measure, plural, one {# hour} other {# hours}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.HOURS_MINUTE:
                if (this.state.format === 'short') {
                    return `${this.parseHoursMinutes()} h`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.hour_label_long"
                        defaultMessage="{measure, plural, one {# hour} other {# hours}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.MINUTE:
                if (this.state.format === 'short') {
                    return `${this.state.measure} min`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.minute_label_long"
                        defaultMessage="{measure, plural, one {# minute} other {# minutes}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.MONTH:
                if (this.state.format === 'short') {
                    return `${this.state.measure} mo`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.month_label_long"
                        defaultMessage="{measure, plural, one {# month} other {# months}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.YEAR:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.year_label_short"
                        defaultMessage="{measure, plural, one {# yr} other {# yrs}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.year_label_long"
                        defaultMessage="{measure, plural, one {# year} other {# years}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.TRAVEL:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.travel_label_short"
                        defaultMessage="{measure, plural, one {# travel} other {# travels}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.travel_label_long"
                        defaultMessage="{measure, plural, one {# travel} other {# travels}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.QUARTER:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.quarter_label_short"
                        defaultMessage="{measure, plural, one {# qtr} other {# qtr}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.quarter_label_long"
                        defaultMessage="{measure, plural, one {# quarter} other {# quarters}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.PAGE:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.page_label_short"
                        defaultMessage="{measure, plural, one {# p} other {# p}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.page_label_long"
                        defaultMessage="{measure, plural, one {# page} other {# pages}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.PARTICIPANT:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.participant_label_short"
                        defaultMessage="{measure, plural, one {# p} other {# ps}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.participant_label_long"
                        defaultMessage="{measure, plural, one {# participant} other {# participants}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.PERSON:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.person_label_short"
                        defaultMessage="{measure, plural, one {# pers} other {# pers}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.person_label_long"
                        defaultMessage="{measure, plural, one {# person} other {# persons}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.USE:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.user_label_short"
                        defaultMessage="{measure, plural, one {# user} other {# users}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.user_label_long"
                        defaultMessage="{measure, plural, one {# user} other {# users}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.GIGABYTE:
                if (this.state.format === 'short') {
                    return `${this.state.measure} GB`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.gigabyte_label_long"
                        defaultMessage="{measure, plural, one {# gigabyte} other {# gigabytes}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.MEGABYTE:
                if (this.state.format === 'short') {
                    return `${this.state.measure} MB`
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.megabyte_label_long"
                        defaultMessage="{measure, plural, one {# megabyte} other {# megabytes}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.ASSET:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.asset_label_short"
                        defaultMessage="{measure, plural, one {# asset} other {# assets}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.asset_label_long"
                        defaultMessage="{measure, plural, one {# asset} other {# assets}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.EPISODE:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.episode_label_short"
                        defaultMessage="{measure, plural, one {# ep.} other {# ep.}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                    return <FormattedMessage
                        id="common.unit_of_measure.input.episode_label_long"
                        defaultMessage="{measure, plural, one {# episode} other {# episodes}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.TALENT:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.talent_label_short"
                        defaultMessage="{measure, plural, one {# tal.} other {# tal.}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.talent_label_long"
                        defaultMessage="{measure, plural, one {# talent} other {# talents}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.SQUARE_FOOT:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.square_foot_label_short"
                        defaultMessage="{measure, plural, one {# ft²} other {# ft²}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.square_foot_label_long"
                        defaultMessage="{measure, plural, one {# square foot} other {# square feet}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
            case UNIT_OF_MEASURE.SERVING:
                if (this.state.format === 'short') {
                    return <FormattedMessage
                        id="common.unit_of_measure.input.serving_label_short"
                        defaultMessage="{measure, plural, one {# srv} other {# srvs}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                }
                return <FormattedMessage
                        id="common.unit_of_measure.input.serving_label_long"
                        defaultMessage="{measure, plural, one {# serving} other {# servings}}"
                        values={{
                            measure: this.state.measure
                        }}
                    />
                
        }
    }

    render() {
        return <span>
            {this.renderUnit()}
        </span>
    }
}

export default LabelUnitOfMeasure





// WEBPACK FOOTER //
// ./src/common/unit-of-measure/label.component.jsx